import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	heartbeatsTitle: {
		id: 'eoc.heartbeats.breadcrumbs.title.no-translate',
		defaultMessage: 'Heartbeats',
		description: 'The title of heartbeats.',
	},
	teams: {
		id: 'eoc.heartbeats.breadcrumbs.teams.no-translate',
		defaultMessage: 'Teams',
		description: 'The text will be displayed on the breadcrumb for Team list navigation',
	},
});

export default messages;
